export const ONE_MO_SIZE = 1048576;
export const THREE_MO_SIZE = 3145728;
export const FIVE_MO_SIZE = 5242880;

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < ONE_MO_SIZE) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / ONE_MO_SIZE).toFixed(1)} Mo`;
}
